const WHITE = 'https://s3.us-east-1.amazonaws.com/co.knocking.images/knocking_typography_white_no_bg.png';
const BLACK = 'https://s3.us-east-1.amazonaws.com/co.knocking.images/knocking_typography_black_no_bg.png';

/** Knocking wordmark — white on dark, black on light, toggled via data-theme. */
export function Logo({ className = 'h-[34px]' }: { className?: string }) {
  return (
    <span className="inline-flex">
      <img src={BLACK} alt="Knocking" height={34} className={`${className} w-auto dark:hidden`} />
      <img src={WHITE} alt="" aria-hidden className={`${className} hidden w-auto dark:inline`} />
    </span>
  );
}
